
import { mapGetters } from 'vuex'
import SearchCard from '../Search/SearchCard.vue'
import EralpPagination from 'gurhan/vue/BootstrapPagination.vue'
import NoFound from '../Shared/NoFound/index.vue'
import Payment from './Payment'
import ProductAlert from './ProductAlert.vue'
import Upload from '../Shared/Upload/index.vue'
import Accordion from '../Shared/Accordion/index.vue'
import GetOffer from './GetOffer.vue'
import AnswerToOffer from './AnswerToOffer.vue'
import Purchase from '@/components/Contents/PurchaseAction/Purchase.vue'

export default {
  mixins: [Payment],
  components: {
    SearchCard,
    NoFound,
    EralpPagination,
    GetOffer,
    AnswerToOffer,
    ProductAlert,
    Upload,
    Accordion,
    Purchase
  },
  data() {
    return {
      page: 1,
      showPayments: false,
      product: {}

    }
  },
  computed: {
    ...mapGetters({
      getRedirectUrl: 'getRedirectUrl',
      getUserIP: 'user/getUserIP',
      getBooks: 'profile.books/getBooks',
      getCount: 'profile.books/getBooksCount',
      getBooksLoading: 'profile.books/getBooksLoading',
    }),
    pages() {
      return Math.ceil(this.getCount / 12)
    },
  },
  methods: {
    BUY_IT_OFFER(product) {
      this.product = product
      this.showPayments = true;
    },
    async SET_PAGINATION(page) {
      this.page = page
      await this.$store.dispatch('profile.books/GET_BOOKS', {
        page: this.page,
        currency: this.getUserIP.currency,
      })
    },
  },
  async mounted() {
    await this.$store.dispatch('profile.books/GET_BOOKS', {
      page: 1,
      currency: this.getUserIP.currency,
    })
  },
}
